import { styled } from '@mui/material';
import FinishedSignupPage from 'components/SignUp/FinishedSignupPage';
import { useAuth } from 'contexts/auth';
import { useSnackbar } from 'contexts/snackbar';
import { useViewport } from 'contexts/viewport';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import { Container, Logo, Stack } from 'shell/components';

const ConfirmSignUp = () => {
    const { device } = useViewport();
    const { verifyUser, resendConfirmationCode } = useAuth();
    const { message } = useSnackbar();
    const { t } = useTranslation();
    const history = useHistory();
    const location = useLocation();
    const email = location.state?.email || sessionStorage.getItem('timelygrader.pendingAuthEmail') || '';
    const [code, setCode] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleConfirmationCode = async () => {
        if (!code.trim()) return setError('Enter a valid code');
        setLoading(true);
        try {
            await verifyUser(email, code.trim());
            sessionStorage.removeItem('timelygrader.pendingAuthEmail');
            message.success(t('common:message.verification-success', 'Verification successful. Please log in again'));
            history.push('/login', { email });
        } catch (caughtError) {
            setError(
                caughtError?.name === 'ExpiredCodeException'
                    ? 'The code has expired; please resend the email'
                    : 'Enter a valid code'
            );
        } finally {
            setLoading(false);
        }
    };

    if (!email) {
        history.replace('/login');
        return null;
    }

    return (
        <Container device={device} sx={{ minHeight: '100%' }}>
            <PageStack alignItems={'center'}>
                <Logo device={'desktop'} />
                <FinishedSignupPage
                    device={device}
                    email={email}
                    code={code}
                    error={error}
                    loading={loading}
                    handleChange={(_key, value) => setCode(value)}
                    handleConfirmationCode={handleConfirmationCode}
                    handleResendCode={() => resendConfirmationCode(email)}
                />
            </PageStack>
        </Container>
    );
};

const PageStack = styled(Stack)(({ theme }) => ({ paddingTop: theme.spacing(18) }));

export default ConfirmSignUp;
